export default {"src":"/_next/static/media/residential10.a54aca0f.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};